export type CenterLayout = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type Bounds = {
  left: number;
  top: number;
  right: number;
  bottom: number;
};

export const HUD_BALANCE_BOUNDS: Bounds = {
  left: 24,
  top: 24,
  right: 192,
  bottom: 88,
};

export const HUD_DAILY_COIN_BOUNDS: Bounds = {
  left: 72,
  top: 100,
  right: 144,
  bottom: 172,
};

/** Pod saldem, ale na prawo od opcjonalnej monety dziennej. */
export const WORLD_BACK_BUTTON_LAYOUT: CenterLayout = {
  x: 250,
  y: 136,
  width: 200,
  height: 64,
};

export function boundsFromCenter(layout: CenterLayout): Bounds {
  return {
    left: layout.x - layout.width / 2,
    top: layout.y - layout.height / 2,
    right: layout.x + layout.width / 2,
    bottom: layout.y + layout.height / 2,
  };
}

export function intersects(a: Bounds, b: Bounds): boolean {
  return !(
    a.right <= b.left ||
    a.left >= b.right ||
    a.bottom <= b.top ||
    a.top >= b.bottom
  );
}
